import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  headerMenus = [
    { routeLink: '/programs', lable: 'Programs', img: '../../../assets/images/Vector.png', active: false },
    { routeLink: '/court-booking', lable: 'Court Hire', img: '../../../assets/images/Vector (1).png', active: false },
    { routeLink: '/birthday-party', lable: 'Birthday Party', img: '../../../assets/images/Vector (1).png', active: false },
    { routeLink: '/events', lable: 'Events', img: '../../../assets/images/Group 7.png', active: false },
    { routeLink: '/leagues', lable: 'Leagues', img: '../../../assets/images/leagues.svg', active: false },
    { routeLink: '/create-team', lable: 'Create Team', img: '../../../assets/images/Group 7.png', active: false },
    // { routeLink: '/create-player', lable: 'Create Player', img: '../../../assets/images/Group 7.png', active: false },
    // { routeLink: '/venues', lable: 'Venues', img: '../../../assets/images/Icon.png', active: false },
    { routeLink: '/rules', lable: 'Rules', img: '../../../assets/images/Group.png', active: false },
  ];
  isLogin = false;
  menuList: any = [];
  loginUser: any = null;
  mobileMenu: any = false;
  constructor(public authService: AuthService, public router: Router) {
  }

  ngOnInit(): void {
    this.isLogin = this.authService.isLoggedIn();
    this.loginUser = JSON.parse(localStorage.getItem("UserProfile") as any);
    console.log('loginUser', this.loginUser);
    this.menuList = [
      { label: 'My Bookings', icon: '../../../assets/images/my-booking-icon.svg', link: '/my-bookings' },
      { label: 'Log out', icon: '../../../assets/images/logout-icon.svg', link: '/login' },
    ];
  }

  clickOnMenu(i: any) {
    this.headerMenus.map((x, j) => x.active = (j == i) ? true : false);
    this.hideMobileMenu();
  }
  navigation(data: any, op: any): any {
    op.hide();
    if (data.link === '/login') {
      this.authService.logout();
      return false;
    }
    this.router.navigate([data.link]);
    this.hideMobileMenu();
  }
  hideMobileMenu() {
    this.mobileMenu = false;
  }
}